import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileStickyCta from "./MobileStickyCta";

const Layout = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0C] text-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileStickyCta />
    </div>
  );
};

export default Layout;
